const init = () => {
   console.log('init');

   // const customElements = document.getElementsByTagName("hubspot-form");

   // if (customElements.length) {
   /*
   const customElement = customElements[0];
   console.log('customElement', customElement);
   var parentElement = customElement.parentNode;
   console.log('parentElement', parentElement);
   */

   // Create the script tag
   let script = document.createElement('script');
   script.setAttribute('type', 'text/javascript');
   script.setAttribute('defer', false);
   script.textContent = `
      hbspt.forms.create({
         region: "na1",
         portalId: "4910648",
         formId: "69409677-64fb-4bab-9f01-ccda2a6cd4d8"
      });
   `;
   console.log('script', script);
   return script;

}

class HubspotFormElement extends HTMLElement {
   constructor() {
      super();
   }

   connectedCallback() {
      console.log('connectedCallback');
      this.appendChild(init());
   }
}

customElements.define('como-dominar-la-contratacion-en-multiples-sucursales', HubspotFormElement);